"use client";
import React from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import FormatDate from "@/utils/FormatDate";
import ReadingTime from "@/utils/ReadingTime";
import Image from "next/image";
import BlogCard_Thumbnail from "@/assets/image/BlogCard_Thumbnail.jpg";
import {getReadingTime} from "@/helpers/readingTime";

// import "swiper/css";

const RelatedBlogs = ({ blogs, article }) => {
  const currentSlug = article?.slug || article?.attributes?.slug;
  const currentDocumentId = article?.documentId || article?.attributes?.documentId;

  const relatedBlogs = (blogs || [])
    .filter((blog) => {
      const blogSlug = blog?.slug || blog?.attributes?.slug;
      const blogDocumentId = blog?.documentId || blog?.attributes?.documentId;

      if (!blogSlug) return false;
      if (blogSlug === currentSlug) return false;
      if (blogDocumentId && currentDocumentId && blogDocumentId === currentDocumentId) {
        return false;
      }

      return true;
    })
    .slice(0, 6);

  if (relatedBlogs.length === 0) return null;

  return (
    <section className="px-[var(--container-padding)] max-w-[var(--max-page-width)] mx-auto mb-[80px] md:mb-[100px]">
      <h2 className="mt-10 md:mt-16 text-[22px] sm:text-[24px] md:text-[28px] lg:text-[30px] leading-tight mb-6 text-[#202124]">
        Related Blogs
      </h2>

      <Swiper
        spaceBetween={16}
        breakpoints={{
          0: {
            slidesPerView: 1.1,
          },
          640: {
            slidesPerView: 1.3,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {relatedBlogs.map((blog) => {
          const imageUrl = blog?.cover?.url || BlogCard_Thumbnail;

          return (
            <SwiperSlide key={blog.id}>
              <Link href={`/blog/${blog.slug}`} className="block group">
                {/* Image */}
                <div className="relative w-full aspect-16/10 overflow-hidden mb-3">
                  <Image
                    src={imageUrl}
                    alt={blog.cover?.alternativeText || blog.title}
                    fill
                    sizes="(max-width: 640px) 90vw, (max-width: 1024px) 45vw, 30vw "
                    className="object-cover transition-transform duration-300"
                  />
                </div>

                {/* Category */}
                <span className="inline-block text-xs font-medium text-[#EB9100] bg-[#FFF0D7] px-2 py-1 mb-2">
                  {blog.category?.name}
                </span>

                {/* Title */}
                <h4 className="line-clamp-2 text-[16px] md:text-[18px] font-semibold text-[#202124] group-hover:text-[#005D82] transition-colors">
                  {blog.title}
                </h4>

                {/* Description */}
                <p className="line-clamp-2 text-[14px] md:text-[16px] text-[#000000] mt-1 mb-2">
                  {blog.description}
                </p>

                {/* Meta */}
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-[#63778B]">
                  <span>{blog.author?.name}</span>
                  <span className="w-1 h-1 bg-[#D7DFE6] rounded-full" />
                  <span>{FormatDate(blog.updatedAt)}</span>
                  <span className="w-1 h-1 bg-[#D7DFE6] rounded-full" />
                  <span>
                    {getReadingTime(
                      (blog.blocks || [])
                        .map((block) => block.Editor || block.body || "")
                        .join(" "),
                    )}
                  </span>
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default RelatedBlogs;
